import styled from '@emotion/styled'
import type { FC, PropsWithChildren } from 'react'

import Image from '@segment/matcha/components/Image'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import introductionPng2x from './assets/Introduction@2x.png'
import introductionWebp from './assets/Introduction.webp'
import introductionWebp2x from './assets/Introduction@2x.webp'

const description = [
  `Over the past 10 years, the "growth at all costs" mindset has been the norm. Build, build more, build better, build at all costs. Just get growing.`,
  `Today, business growth looks dramatically different. With a variety of factors at play, from a tumultuous global economy to businesses shifting how and where they work, the growth over all else mindset is officially over. In its place is a more strategic, calculated shift to growth, where businesses are doubling down on sustainable paths to growth, such as long-term customer loyalty, and profitability.`,
  `In our annual Growth Report, Twilio Segment surveyed leaders from across industries about what this shift means for the future of doing business. Here are our top takeaways about what growing as a business means today.`,
]

const Introduction: FC<PropsWithChildren<unknown>> = () => {
  return (
    <SectionBase variant="2Col">
      <Section.Copy>
        <CopyTextBase>
          {description.map((item, index) => (
            <StyledDescription tag="p" key={index}>
              {item}
            </StyledDescription>
          ))}
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <picture>
          <source type="image/webp" srcSet={`${introductionWebp}, ${introductionWebp2x} 2x`} />
          <Image src={introductionPng2x} width="520" height="659" alt="Illustration: Introduction" />
        </picture>
      </Section.Contents>
    </SectionBase>
  )
}

const StyledDescription = styled(CopyText.Description)`
  margin-bottom: 30px;
`

export default Introduction
